document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll(".collapsible-content__item details summary")
    .forEach((summary) => {
      summary.addEventListener("click", function (e) {
        e.preventDefault(); // Stop native toggle

        const currentDetails = this.parentElement;
        const container = currentDetails.closest(".collapsible-content__item");

        // Close all others
        container.querySelectorAll("details").forEach((detail) => {
          if (detail !== currentDetails) {
            detail.removeAttribute("open");
          }
        });

        // Toggle current
        if (currentDetails.hasAttribute("open")) {
          currentDetails.removeAttribute("open");
        } else {
          currentDetails.setAttribute("open", "open");
        }
      });
    });
});
